import {library} from '@fortawesome/fontawesome-svg-core';
import {
    faAngleDoubleDown,
    faAngleRight,
    faBracketsCurly,
    faCaretUp,
    faCheckCircle,
    faCog,
    faCloudUpload,
    faClone,
    faEmptySet,
    faEye,
    faExpandArrowsAlt,
    faFilter,
    faFlower,
    faHistory,
    faInfoCircle,
    faPencil,
    faPencilAlt,
    faPlay,
    faPlus,
    faPlusCircle,
    faRepeat,
    faSave,
    faSpinner,
    faSquare,
    faStream,
    faTasksAlt,
    faTimes,
    faTrashAlt,
} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import Vue from 'vue';

library.add(
    faAngleDoubleDown,
    faAngleRight,
    faBracketsCurly,
    faCaretUp,
    faCheckCircle,
    faCloudUpload,
    faCog,
    faClone,
    faEmptySet,
    faEye,
    faExpandArrowsAlt,
    faFilter,
    faFlower,
    faHistory,
    faInfoCircle,
    faPencil,
    faPencilAlt,
    faPlay,
    faPlus,
    faPlusCircle,
    faRepeat,
    faSave,
    faSpinner,
    faSquare,
    faStream,
    faTasksAlt,
    faTimes,
    faTrashAlt,
);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
